import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { strings } from '../../../resources/strings';
import { ReportService } from '../ReportService';
import { GenerateShippingGuideReportInput } from './GenerateShippingGuideReportInput';

export class GenerateShippingGuideReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GenerateShippingGuideReportInput, version?: number) => {
    const urlVersion = version && version > 0 ? `/v${version}` : '';
    this.http.postToDownloadFile<GenerateShippingGuideReportInput>(
      `${this.baseUrlSislogApi}/v2/report-shipping-guide${urlVersion}`,
      input
    ).then(result => {
      this.report.openPdf(result);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingReport);
    });
  }
}